module.exports = __webpack_public_path__ + "assets/img/btn-back-bb6d700a.png";